<div class="modal-overlay" *ngIf="isVisible" (click)="onClose()">
  <div class="filter-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">Filters</h2>
        <button class="close-button" (click)="onClose()">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 3L3 9M3 3L9 9"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Filter Content -->
    <div class="filter-content">
      <div class="filter-sections">
        <!-- Car Wash Type Section -->
        <div class="filter-section">
          <h3 class="section-title">Package Type</h3>
          <div class="options-container">
            <div class="option-row">
              <div
                class="checkbox-group"
                *ngFor="let option of carWashTypeOptions; trackBy: trackByValue"
              >
                <app-checkbox
                  [checked]="selectedCarWashTypes.includes(option.value)"
                  [label]="option.label"
                  (checkedChange)="onToggleSelection(selectedCarWashTypes, option.value, $event)"
                ></app-checkbox>
              </div>
            </div>
          </div>
        </div>

        <!-- Status Section -->
        <div class="filter-section">
          <h3 class="section-title">Status</h3>
          <div class="options-container">
            <div class="option-row">
              <div
                class="checkbox-group"
                *ngFor="let option of statusOptions; trackBy: trackByValue"
              >
                <app-checkbox
                  [checked]="selectedStatuses.includes(option.value)"
                  [label]="option.label"
                  (checkedChange)="onToggleSelection(selectedStatuses, option.value, $event)"
                ></app-checkbox>
              </div>
            </div>
          </div>
        </div>

        <!-- Location Section -->
        <div class="filter-section">
          <h3 class="section-title">Location</h3>
          <div class="options-container">
            <div class="locations-grid">
              <div
                class="location-row"
                *ngFor="let option of locationOptions; let i = index; trackBy: trackByIndex"
              >
                <app-checkbox
                  [checked]="selectedLocations.includes(option.value)"
                  [label]="option.label"
                  (checkedChange)="onToggleSelection(selectedLocations, option.value, $event)"
                ></app-checkbox>
              </div>
            </div>
          </div>
        </div>

        <!-- Sort By Section -->
        <!-- <div class="filter-section">
          <h3 class="section-title">Sort By</h3>
          <div class="sort-options">
            <div class="sort-grid">
              <div class="sort-row" *ngFor="let option of sortByOptions; let i = index; trackBy: trackByIndex">
                <div class="p-field-radiobutton">
                  <mat-radio-button 
                    
                    [value]="option.value"
                    [(ngModel)]="selectedSortBy"
                    name="sortBy"
                  ></mat-radio-button>
                  <label [for]="'sort-' + option.value" class="radio-label">{{ option.label }}</label>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- Modal Footer -->
    <app-modal-footer-actions
      footerClass="modal-footer"
      secondaryText="Clear Filters"
      primaryText="Apply Filters"
      [secondaryDisabled]="!hasActiveFilters()"
      [cancelDesktopOnly]="true"
      (secondaryClick)="onClearFilters()"
      (cancelClick)="onCancel()"
      (primaryClick)="onApplyFilters()"
    />
  </div>
</div>
